module.exports = __webpack_public_path__ + "e977e1c18eb7eed6ed70e95620fc3f67.png";